var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 8.136,
    y: 10.364,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.75,
    rx: 1.5,
    transform: "rotate(90 8.136 10.364)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 2.856,
    y: 4.671,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.87,
    rx: 1.5,
    transform: "rotate(-45 2.856 4.671)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 10.864,
    y: 16.364,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.51,
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 8.256,
    y: 13.929,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.63,
    rx: 1.5,
    transform: "rotate(45 8.256 13.929)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 14.43,
    y: 16.242,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.39,
    rx: 1.5,
    transform: "rotate(-45 14.43 16.242)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 24.5,
    y: 10.364,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.27,
    rx: 1.5,
    transform: "rotate(90 24.5 10.364)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 19.83,
    y: 2.357,
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.15,
    rx: 1.5,
    transform: "rotate(45 19.83 2.357)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 7.636,
    x: 10.864,
    fill: "currentColor",
    fillOpacity: 0.8,
    rx: 1.5
  })));
};
export default SvgSpinner;